import React, { createContext, useContext, useState } from 'react';
import { IonToast } from '@ionic/react';
import { checkmarkCircle, closeCircle, informationCircle, warningOutline } from 'ionicons/icons';

const ToastContext = createContext();

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    console.error('useToast called outside ToastProvider. Component tree:', new Error().stack);
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ 
    isOpen: false, 
    message: '', 
    color: 'primary', 
    icon: null,
    duration: 4000,
    position: 'bottom'
  });

  const showToast = (message, type = 'primary', options = {}) => {
    let icon;
    let color = type;
    
    switch(type) {
      case 'success':
        icon = checkmarkCircle;
        color = 'success';
        break;
      case 'error':
      case 'danger':
        icon = closeCircle;
        color = 'danger';
        break;
      case 'warning':
        icon = warningOutline;
        color = 'warning';
        break;
      case 'info':
        icon = informationCircle;
        color = 'primary';
        break;
      default:
        icon = null;
        color = type;
    }
    
    setToast({ 
      isOpen: true, 
      message, 
      color,
      icon,
      duration: options.duration || 6000,
      position: options.position || 'top'
    });
  };

  const hideToast = () => {
    setToast(prev => ({ ...prev, isOpen: false }));
  };

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {children}
      <IonToast
        isOpen={toast.isOpen}
        onDidDismiss={hideToast}
        message={toast.message}
        duration={toast.duration}
        icon={toast.icon}
        position={toast.position}
        cssClass="custom-toast"
      />
    </ToastContext.Provider>
  );
};
